import script from "./ADC3-2.vue?vue&type=script&setup=true&lang=js"
export * from "./ADC3-2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__